package fi.bullpen.kmpapp.data.turnkey.dto

import kotlinx.serialization.Serializable

@Serializable
data class CreateAuthenticatorsIntentV2(
    val userId: String,
    val authenticators: List<AuthenticatorParamsV2>,
): Intent